export default "__VITE_ASSET__dbb6d50b__"